import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import React from 'react';

import { useOptions } from 'entities/pledgeAutoForm';

export const CarBrand: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { brands } = useOptions();

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={brands}
    />
  );
};
